<template>
  <div>
    <div
      class="row pt-4"
      id="filter0">
      <div class="Search">
        <div class="col s12">
          <span class="Search__title grey-text">Por Autor: </span>
        </div>
        <div
          class="chip mt-3"
          v-for="autor in autoresSelecionados"
          v-bind:key="autor.funcionario_id"
        >
          {{autor.pessoa_nome}}
          <i
            class="close material-icons"
            @click="removerAutorSelecionado(autor)">
            close
          </i>
        </div>

        <div class="Search input-field col s12 input-search">
          <i class="material-icons">person_outline</i>
          <input
            type="text"
            @input="debounceAutores"
            class="autocomplete"
            id="autor-input">
          <i
            @click="limparCampoAutor()"
            class="material-icons md-18 grey-text clear">
            clear
          </i>
          <label for="nome"/>
        </div>
      </div>
    </div>

    <ul
      class="collection"
      v-if="checarCargoFuncionario(
        [cargoDono, cargoGerente, cargoEspecialista],
        [cargoDono, cargoGerente, cargoEspecialista])"
    >
      <li
        class="collection-item pl-0 pr-0"
        style="display: flex;justify-content: space-between;"
        v-for="autor in autoresPadrao.itens"
        v-bind:key="autor.funcionario_id">
        <span
          class="title"
          style="text-transform: capitalize; font-size: .9rem">
          {{ autor.pessoa_nome.toLowerCase() }}
        </span>
        <div class="secondary-content">
          <input
            :id="'autor'+autor.funcionario_id"
            :value="autor.funcionario_id"
            type="checkbox"
            v-model="autores"
            @change="change()"
          />
          <label :for="'autor'+autor.funcionario_id"/>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { debounce } from "lodash";
import * as constant from "@/constants/funcionarioCargo.js";
import { get } from "@/helpers/api";
import { checaCargo } from "@/helpers/perfil";
import { listarPessoas, recuperarSelecionados } from "./funcoesFiltro";

export default {
  name: "FiltroPorAutores",

  props: {
    autores: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    autoresSelecionados: [],

    autoresPadrao: {
      itens: [],
      typed: null
    },

    cargoDono: constant.DONO,
    cargoGerente: constant.GERENTE,
    cargoCorretor: constant.CORRETOR,
    cargoEspecialista: constant.ESPECIALISTA,
    cargoParceiro: constant.PARCEIRO,
    cargoMaster: constant.MASTER
  }),

  watch: {
    "autoresPadrao.typed"() {
      this.autoresPadrao.itens = [];
      if (this.autoresPadrao.typed) {
        listarPessoas(this.autores, this.autoresPadrao.typed)
          .then(response => {
            this.autoresPadrao.itens = response;
        });
      };
    },

    autores: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        this.gerarSelecionados(newValue, oldValue);
      }
    },

  },

  async created() {
    this.autoresSelecionados = await recuperarSelecionados(this.autores);
  },

  methods: {

    change()
    {
      this.$emit('change', { autores: this.autores, autoresSelecionados: this.autoresSelecionados });

      this.$emit('update:autores', this.autores);
    },
    gerarSelecionados(newValue, oldValue) {

      if (oldValue === undefined) return;

      let newData = [...newValue];
      newData = newData.pop();

      if (!oldValue.includes(newData)) {

        const dataToPush = this.autoresPadrao.itens.filter(
          item => item.funcionario_id == newData
        );

        if (dataToPush.length) {
          const newItem = dataToPush.pop();

          if(!this.autoresSelecionados.find(i => i == newItem)) {
            this.autoresSelecionados.push(newItem);
          };
        }
      }
    },

    checarCargoFuncionario(cargoMono, cargoMulti) {
      return checaCargo(cargoMono, cargoMulti);
    },


    removerAutorSelecionado(item) {

      this.autoresSelecionados = this.autoresSelecionados.filter(i => i != item);

      const novaListaAutores = this.autores.filter(
        i => i.toString() != item.funcionario_id.toString());

      this.autores = novaListaAutores;

      this.$emit("removeSelecionado", {
        autores: this.autores,
        autoresSelecionados: this.autoresSelecionados
      });

      this.$emit('update:autores', this.autores);
    },

    limparCampoAutor() {
      this.autoresPadrao.typed = "";
      $("#autor-input").val("");
    },

    debounceAutores: debounce(function(e) {
      let time;
      clearTimeout(time);
      const self = this;
      time = setTimeout(
        () => (self.autoresPadrao.typed = e.target.value),
        500
      );
    }, 200),
  },
}
</script>

<style scoped>
  div#filter0 {
    border-top: 1px solid #e0e0e0
  }
</style>



// WEBPACK FOOTER //
// src/components/lead/listagem/FiltroPorAutores.vue